import React from 'react';
import loadable from '@loadable/component';

const AdvancedFilter = loadable(
  () => import(/* webpackChunkName: "AdvancedFilter.loadable" */ 'app/shared/modules/filter/AdvancedFilter/component'),
);

interface LoadableAdvancedFilterProps {
  closeFilter: () => void;
}

class LoadableAdvancedFilter extends React.Component<LoadableAdvancedFilterProps> {
  render() {
    return <AdvancedFilter {...this.props} />;
  }
}

export default LoadableAdvancedFilter;
